module.exports = __webpack_public_path__ + "static/nextlevel-sm-9cb3b74cd921ae26ef53260e59ff0d6e.jpg";